import { getUserFromToken } from "./../../utils/auth";
import { atom } from "recoil";

interface AuthState {
  token: string | null;
  role: "admin" | "restaurantAdmin" | "user" | null;
  restaurantId?: number | null;
  branchId?: number | null;
}
export const authState = atom<AuthState>({
  key: "authState",
  default: {
    token: localStorage.getItem("token"),
    role: getUserFromToken(localStorage.getItem("token") || "")?.role || null,
    restaurantId:
      getUserFromToken(localStorage.getItem("token") || "")?.restaurantId ||
      null,
    branchId:
      getUserFromToken(localStorage.getItem("token") || "")?.branchId || null,
  },
});
